import React from "react";
import { useSelfUser } from "../reducers/accounts/user";
import { Link } from "react-router-dom";
const navbarLogo = require("../assets/images/favicon.png");

const Navbar = () => {
  const { user } = useSelfUser();
  // console.log(user);
  const handleNavClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let navItem = e.target.closest(".nav-item");
    let menu = navItem.querySelector(".dropdown-menu");
    if (navItem.classList.contains("show")) {
      navItem.classList.remove("show");
      menu.classList.remove("show");
    } else {
      navItem.classList.add("show");
      menu.classList.add("show");
    }
  };
  return (
    <>
      <div className="header-container fixed-top no-print">
        <header className="header navbar navbar-expand-sm">
          <ul className="navbar-item flex-row">
            <li className="nav-item theme-logo">
              <a href="javascript:void(0);">
                <img src={navbarLogo} className="navbar-logo" alt="logo" />
              </a>
            </li>
          </ul>

          {/* <a href="javascript:void(0);" className="sidebarCollapse" data-placement="bottom"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg></a> */}

          <ul
            className="navbar-item flex-row navbar-dropdown"
            style={{ marginLeft: "auto" }}
          >
            {/* <li className="nav-item dropdown language-dropdown more-dropdown">
                            <div className="dropdown  custom-dropdown-icon">
                                <a className="dropdown-toggle btn" href="#" role="button" id="customDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Active organization
                                </a>
                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="customDropdown">
                                    
                                    <a className="dropdown-item setsessionorganization" href="javascript:void(0);" data-id="{{org.id}}">
                                        Organization list item
                                    </a>
                                </div>
                            </div>
                        </li> */}

            <li className="nav-item dropdown user-profile-dropdown  order-lg-0 order-1">
              <Link
                to="#"
                onClick={handleNavClick}
                className="nav-link dropdown-toggle user"
                id="userProfileDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  src={user?.profile_pic_url}
                  alt={user?.full_name}
                  className="img-fluid"
                />
              </Link>
              <div
                className="dropdown-menu position-absolute animated fadeInUp"
                aria-labelledby="userProfileDropdown"
              >
                <div className="user-profile-section">
                  <div className="media mx-auto" style={{ display: "flex" }}>
                    <img
                      src={user?.profile_pic_url}
                      alt={user?.full_name}
                      className="img-fluid me-2"
                    />
                    <div className="media-body">
                      <h5>{user?.full_name}</h5>
                      <p>{user?.designation}</p>
                    </div>
                  </div>
                </div>
                {/* <div className="dropdown-item">
                                    <a href="{% url 'profile' %}">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> <span>My Profile</span>
                                    </a>
                                </div> */}
                <div className="dropdown-item">
                  <a
                    href="/user/logout/?next=/dashboard/sales/"
                    style={{ textDecoration: "none" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="feather feather-log-out"
                    >
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                      <polyline points="16 17 21 12 16 7"></polyline>
                      <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>{" "}
                    <span>Log Out</span>
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </header>
      </div>
    </>
  );
};

export default Navbar;
